import React from 'react';
import { Superpowersection, Title } from '../Aboutmylo/styled';

export default function index() {
  return (
    <Superpowersection>
      <Title>In Mylo, you will find many AMAZING TOPICS</Title>
      <p>Tips about conception, pregnancy, parenting</p>
      <p>Pregnancy/conception/baby tools, utilities, guides</p>
      <p>
        You can ask question that you can&apos;t wait to ask your doctor, and
        get answer from a helpful community of experienced mothers on the Mylo
        Pregnancy and Parenting app within 5 MINUTES
      </p>
      <p>
        You will get to know all about pregnancy and parenting - from pregnancy
        tests to parental yoga normal labor, baby names, diet and nutrition,
        miscarriage, baby food and everything else needed to understand your
        maternal journey and from thinnking about having a baby to what to do
        when your baby arrives.
      </p>
      <p>
        Mylo is personalized for your stafe - how to get pregnant, what to do
        after getting pregnant, preparing for your baby, and what to do once the
        baby arrives. You can even enjoy funny short videos, jokes, GIFs,
        motivational qoutes, funny qoutes, bhajans, devotional songs and funny
        images all in one platform.
      </p>
      <p>
        Mylo Pregnancy and Parenting app offers all features FREE, and much more
        to help you take care of your adorable little one
      </p>
    </Superpowersection>
  );
}
